import { useEffect } from "react";

const isDev = process.env.NODE_ENV === "development";

// Core Web Vitals monitoring
export function useWebVitals() {
  useEffect(() => {
    if (typeof window === "undefined" || !isDev) return;

    // LCP
    const lcpObserver = new PerformanceObserver((list) => {
      const entries = list.getEntries();
      const lastEntry = entries[entries.length - 1];
      console.log(`[CWV] LCP: ${Math.round(lastEntry.startTime)}ms`);
    });

    // CLS
    let clsValue = 0;
    const clsObserver = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if (!entry.hadRecentInput) clsValue += entry.value;
      }
      console.log(`[CWV] CLS: ${clsValue.toFixed(4)}`);
    });

    // INP (approximation via event timing)
    const inpObserver = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if (entry.duration > 100) {
          console.log(`[CWV] Slow interaction: ${entry.name} ${Math.round(entry.duration)}ms`);
        }
      }
    });

    try { lcpObserver.observe({ type: "largest-contentful-paint", buffered: true }); } catch (_e) { /* LCP not supported in this browser */ }
    try { clsObserver.observe({ type: "layout-shift", buffered: true }); } catch (_e) { /* CLS not supported in this browser */ }
    try { inpObserver.observe({ type: "event", buffered: true, durationThreshold: 50 }); } catch (_e) { /* Event timing not supported */ }

    return () => {
      lcpObserver.disconnect();
      clsObserver.disconnect();
      inpObserver.disconnect();
    };
  }, []);
}

// Prefetch a route's JS bundle on hover/visibility
export function usePrefetch(path) {
  useEffect(() => {
    if (!path) return;
    const link = document.createElement("link");
    link.rel = "prefetch";
    link.href = path;
    document.head.appendChild(link);
    return () => { try { document.head.removeChild(link); } catch (_e) { /* Link already removed or DOM unmounted */ } };
  }, [path]);
}
